import { translate } from '@/domains/core/localization/translate';
export const {
  nonDeductibleVat,
  allTaxIncludedShort,
  allTaxExcludedShort
} = translate({
  "nonDeductibleVat": "Non-deductible VAT",
  "allTaxIncludedShort": "incl. VAT",
  "allTaxExcludedShort": "excl. VAT"
});